import { axiosInstance } from ".."

const updateCurrency = async (data) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.post(`internal/currency`,data).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default updateCurrency;